<template>
  <div class="drawSetting">
    <div v-show="!showRecord">
      <Button class="mr-2" type="primary" to="self-lottery-draw"
        >返回彩种选择</Button
      >
      <Button class="mr-2" type="primary" @click="showModal = !showModal"
        >已设定号码</Button
      >
      <Button class="mr-2" type="primary" @click="showRecord = !showRecord"
        >操作纪录</Button
      >
      <divider />
      <div class="prompt">
        <p>
          *
          此指定开奖号码功能不受RTP限制所影响；接续的期数若未指定开奖号码，RTP将会调回接近目标值
        </p>
        <p>* 若前一日有更动下注时间，跨日后各期数的开奖时间将会随之变动</p>
        <p>* 跨日期数不显示开奖时间</p>
      </div>
      <div class="all-reload-btn">
        <Button
          type="primary"
          @click="reload"
          :loading="loading"
          icon="ios-loading"
          >全部刷新</Button
        >
      </div>
      <Modal v-model="showModal" width="80%" :footer-hide="true">
        <NumSettedTable :recordBtn="false" ref="numSetted" />
      </Modal>
      <component
        v-for="(item, index) in apiData"
        :key="index"
        :is="PropComponents(item)"
        :data="item"
        :closeRtpTd="CheckCloseRtpTd(item)"
      />
    </div>
    <ActionRecord v-if="showRecord" @close-record="showRecord = !showRecord" />
  </div>
</template>

<script>
import moment from "moment-timezone";
import { mapGetters, mapActions } from 'vuex'
import defaulePeriod from '@/mixins/defaule-period.js'
export default {
  name: 'draw-setting',
  mixins: [defaulePeriod],
  components: {
    NumSettedTable: () => import('./components/NumSettedTable'),
    ActionRecord: () => import('./components/ActionRecord'),
    Pk10Prop: () => import('./game-prop/pk10'),
    Quick10Prop: () => import('./game-prop/quick10'),
    SscProp: () => import('./game-prop/ssc'),
    SixmarkProp: () => import('./game-prop/sixmark'),
    Quick3Prop: () => import('./game-prop/quick3'),
    Select5Prop: () => import('./game-prop/select5'),
    KenoProp: () => import('./game-prop/keno'),
    Tcpl3: () => import('./game-prop/tcpl3'),
    Lto539: () => import('./game-prop/lto539'),
  },
  data () {
    return {
      apiData: {},
      loading: false,
      showModal: false,
      showRecord: false,
      PropClasses: {
        1: 'SixmarkProp',
        2: 'Pk10Prop',
        3: 'SscProp',
        4: 'Quick10Prop',
        5: 'Pk10Prop',
        6: 'Select5Prop',
        8: 'Quick3Prop',
        9: 'SixmarkProp',
        10: 'KenoProp',
        12: 'Tcpl3',
        15: 'Lto539'
      }
    }
  },
  computed: {
    ...mapGetters(['getAllGame', 'getpermission']),
    allGame () {
      if (!this.getAllGame) return []
      return this.getAllGame
    },
    actBtnShow () {
      return this.getpermission.gameset[2]
    }
  },
  watch: {
    showModal (val) {
      if (val && this.$refs.numSetted) this.$refs.numSetted.search()
    }
  },
  created () {
    this.gameData();
  },
  methods: {
    ...mapActions(['allReload']),
    PropComponents (item) {
      if (!item) return
      return this.PropClasses[item.gameGroupId]
    },
    CheckCloseRtpTd (item) {
      if (item.gameGroupId !== 9) return
      return item.listPeriodData.betSeconds < 25200
    },
    async gameData () {
      let defaultState = true // 是否加入預設期數
      try {
        const routeQuery = this.$route.query.gid.split(","); // Router Query
        let res = await this.$axios.gameLobby.GamePeriodMark(routeQuery); // 期数资料
        if ('status' in res && res.status === 0) return
        this.apiData = Object.keys(res).reduce((acc, val) => {
          let gameItems = this.allGame.find(it => it.gameid == val)
          let newMark = res[val].markDataList.map(it => {
            'second' in res[val].listPeriodData ? it.second = res[val].listPeriodData.second : null
            it.mark = it.mark.split(',')
            it.codate = moment(it.endate).subtract(15, 'seconds').format('YYYY-MM-DD HH:mm:ss')
            return it
          }).sort((a, b) => a.period > b.period ? 1 : -1)
          acc[val] = {
            ...gameItems,
            ...res[val],
            markDataList: newMark
          }
          const defaultGameList = this.defaultPeriod(res[val], gameItems.gameGroupId)
          if (!acc[val].markDataList.some(it => it.period == Number(defaultGameList.period))) {
            acc[val].markDataList.unshift(defaultGameList)
          }
          return acc
        }, {})
      } catch (error) {
        console.error(error);
      }
    },
    reload () {
      this.allReload()
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 2000);
    }
  }
};
</script>

<style lang="scss">
.prompt {
  color: #ff0000;
  font-weight: bold;
}

.all-reload-btn {
  z-index: 50;
  position: sticky;
  top: 5%;
  .ivu-btn-small {
    height: auto;
    position: absolute;
    right: -2.15%;
  }
  span {
    padding: 5px 3px;
  }
}
</style>